var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteLineGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 24,
    viewBox: "0 0 92 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 24,
    rx: 12,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.5C11.7239 11.5 11.5 11.7239 11.5 12C11.5 12.2761 11.7239 12.5 12 12.5V11.5ZM80.3536 12.3536C80.5488 12.1583 80.5488 11.8417 80.3536 11.6464L77.1716 8.46447C76.9763 8.2692 76.6597 8.2692 76.4645 8.46447C76.2692 8.65973 76.2692 8.97631 76.4645 9.17157L79.2929 12L76.4645 14.8284C76.2692 15.0237 76.2692 15.3403 76.4645 15.5355C76.6597 15.7308 76.9763 15.7308 77.1716 15.5355L80.3536 12.3536ZM12 12.5H80V11.5H12V12.5Z",
    fill: "#095B7E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLineGray);
export default __webpack_public_path__ + "static/media/whiteLineGray.479461384bcd9bb3b118b354dc17dce3.svg";
export { ForwardRef as ReactComponent };